import { render, staticRenderFns } from "./IndividualForm.vue?vue&type=template&id=5f5d690a"
import script from "./IndividualForm.vue?vue&type=script&lang=ts"
export * from "./IndividualForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports